import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';
import { useLocalisation } from '@3plearning/lingui-cdn';

// Components
import Form from '../form/form';
import Button from '../button/button';

// Others
import { CONFIG_VARS } from '../../helpers/enums';
import { getCorrectErrorMessage } from '../../helpers/utils';

function EditClass({ currentClassId, currentClassName, editClassName, closeHandler }) {
    const { i18n } = useLocalisation();

    // State variables
    const [className, setClassName] = useState(''); // this variable is the one that gets updated locally
    const [errorMessage, setErrorMessage] = useState(null);
    const [bottomErrorMessage, setBottomErrorMessage] = useState(null);
    const trimmedClassName = className.trim();

    // Effects
    useEffect(() => {
        setClassName(currentClassName);
    }, [currentClassName]);

    // Handlers
    const localInputHandler = (e) => {
        // Reset the error messages
        if (errorMessage !== null) {
            setErrorMessage(null);
        }
        if (bottomErrorMessage !== null) {
            setBottomErrorMessage(null);
        }

        // Otherwise continue forward
        const name = e.target.value;
        setClassName(name);
    };
    const saveHandler = async (e) => {
        // Prevent redirect from the default behaviour of a form
        e.preventDefault();

        const value = await editClassName({
            classroomId: currentClassId,
            name: trimmedClassName
        });

        if (value && value.status === 500) {
            const message = <Trans id={'Error Message - Unable to proceed'} />;
            await setBottomErrorMessage(message);
        } else if (value === true) {
            // Afterwards this handler should close the modal
            closeHandler();
        } else if (value.message) {
            const message = getCorrectErrorMessage(value, i18n);
            setErrorMessage(message);
        }
    };

    // This variable describes if the submit button will be disabled or not
    const isFormButtonDisabled = (
        trimmedClassName === '' ||
        currentClassName === className ||
        currentClassName === trimmedClassName
    );

    return (
        <Form formHandler={saveHandler}>
            <div className="form__row">
                <label htmlFor="edit-class-input">
                    <span className="sr-only">
                        <Trans id={'Class Dropdown - header'} />
                    </span>
                </label>
                <input
                    id="edit-class-input"
                    className="form__input"
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus
                    required
                    maxLength={CONFIG_VARS.classNameMaxLength}
                    value={className}
                    placeholder={i18n._(t`Class edit - name placeholder`)}
                    onChange={localInputHandler} />
            </div>
            {
                errorMessage ? (
                    <div className="form__row">
                        <p className="form__error-message">{errorMessage}</p>
                    </div>
                ) : ''
            }
            <div className="form__row form__row--buttons">
                <Button
                    visibleText={<Trans id={'Class edit - Save'} />}
                    isBtnDisabled={isFormButtonDisabled}
                    buttonType="submit"
                />
            </div>
            {
                bottomErrorMessage ? (
                    <div className="form__row">
                        <p className="form__error-message form__error-message--bottom">{bottomErrorMessage}</p>
                    </div>
                ) : ''
            }
        </Form>
    );
}

EditClass.propTypes = {
    currentClassId: PropTypes.number,
    currentClassName: PropTypes.string,
    closeHandler: PropTypes.func,
    editClassName: PropTypes.func
};

export default EditClass;



// WEBPACK FOOTER //
// ./components/classes/edit-class.js